import { VALIDATION_MESSAGE } from '../ValidationMessage';
import { createDateSchema } from './CustomValidation/DateExtendedSchema';
import yup from './CustomValidation/yup-extended';
import { ExtendedDateSchemaType } from './ValidationTypes';

export const CourseCodeValidationSchema = yup.object().shape({
  courseCode: yup
    .string()
    .required(VALIDATION_MESSAGE.REQUIRED)
    .mustBeNumber()
    .min(6, VALIDATION_MESSAGE.EXACT_NUMBER_LENGTH(6))
    .max(6, VALIDATION_MESSAGE.EXACT_NUMBER_LENGTH(6)),
  courseTitle: yup
    .string()
    .required(VALIDATION_MESSAGE.REQUIRED)
    .max(400, VALIDATION_MESSAGE.AT_MOST_CHARS(400)),
  courseDepartmentName: yup
    .string()
    .required(VALIDATION_MESSAGE.REQUIRED)
    .max(60, VALIDATION_MESSAGE.AT_MOST_CHARS(60)),
  scedGradeSpan: yup
    .string()
    .alphaNumeric()
    .min(4, VALIDATION_MESSAGE.EXACT_LENGTH(4))
    .max(4, VALIDATION_MESSAGE.AT_MOST_CHARS(4)),
  scedSequenceOfCourse: yup
    .string()
    .matches(/^[a-zA-Z0-9]*$/, VALIDATION_MESSAGE.LETTERS_AND_NUMBERS_ONLY)
    .max(10, VALIDATION_MESSAGE.AT_MOST_CHARS(10)),
  certificateRequired: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  courseLevelCharacteristic: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  scedCourseSubjectArea: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  courseDescription: yup
    .string()
    .max(4000, VALIDATION_MESSAGE.AT_MOST_CHARS(4000)),
  courseCertificationDescription: yup
    .string()
    .max(300, VALIDATION_MESSAGE.AT_MOST_CHARS(300)),
  courseBeginDate: (createDateSchema() as ExtendedDateSchemaType).required(
    VALIDATION_MESSAGE.REQUIRED
  ),
  courseEndDate: (
    createDateSchema() as ExtendedDateSchemaType
  ).mustComeAfterOrEqualSpecifiedDate('courseBeginDate', 'Course Begin Date'),
  scedGradeSpanMin: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  scedGradeSpanMax: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
});
